import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const LOGIN_VALIDATION_SCHEMA = yup.object().shape({
  email: yup
    .string()
    .typeError(IGNORE_ERROR)
    .email()
    .required("Molimo Vas da unesete ispravnu email adresu"),
  password: yup.string().required("Molimo Vas da unesete ispravnu lozinku"),
});
